import './fullScreenError.css';

export default function FullScreenError() {
  return (
    <div className="container">
      <div className="content">
        <div className="logo-container">
          <div className="logo">
            <img
              alt="logo"
              src="https://tvportal-assets.s3.eu-central-1.amazonaws.com/tvportal/logos/tv-logo-landscape-purple.svg"
            />
          </div>
        </div>
        <h2>We are sorry</h2>
        <h1>An error has occured</h1>
        <p>Please try refreshing the page.</p>
        <p>
          If the error persists please{' '}
          <a href="https://www.tennisviz.com/contact/" rel="noopener" className="contact-support-link">
            contact support
          </a>
        </p>
        <a href={`${window.location.protocol}//${window.location.hostname}`}>
          <button className="home-button">Home</button>
        </a>
      </div>
    </div>
  );
}
